export const liveArticleListData = `
    aResults {
        _id
        dPublishDate
        eStatus
        eType
        oAuthor {
          sFName
        }
        iEventId
        sContent
        sAmpContent
        sTitle
        sEventId
        dCreated
        dUpdated
      }
`
export const liveArticleEventData = `
    oEvent {
      oMatch {
          nLatestInningNumber
          sSubtitle
          oVenue {
            sLocation
          }
          oTeamScoreA {
            oTeam {
              oImg {
                sUrl
                sText
              }
              sAbbr
              sTitle
            }
            sScoresFull
          }
          oTeamScoreB {
            sScoresFull
            oTeam {
              oImg {
                sUrl
              }
              sAbbr
              sTitle
            }
          }
          sStatusStr
          oStatus {
            sValue
            sText
          }
          sStatusNote
          sLiveGameStatusStr
          oLiveGameStatus {
            sText
            sValue
          }
          dStartDate
          oSeo {
            sSlug
          }
      }
      sEventName
      _id
      iMatchId
      dEventDate
      dEventEndDate
      sLocation
    }
`
